function iframeRez() {
  // Get height of the main element in the iframe document
var documentHeight = document.getElementsByTagName("body")[0].scrollHeight;

  // Add some unique identifier to the string being passed
  var message = "documentHeight:" + documentHeight;

  // Pass message to (any*) parent document
  parent.postMessage(message, "*");

  // On resize of the window, recalculate the height of the main element, and pass to the parent document again
  window.onresize = function () {
    var newDocumentHeight =
      document.getElementsByTagName("body")[0].scrollHeight;
    var heightDiff = documentHeight - newDocumentHeight;

    // If difference between current height and new height is more than 10px
    // if (heightDiff > 10 | heightDiff < -10) {

    documentHeight = newDocumentHeight;
    message = "documentHeight:" + documentHeight;
    parent.postMessage(message, "*");
    // }
  };
} 

(function ($) {
  "use_strict";

  var currentSortValue = null;

  $.support.cors = true;

  iframeRez();

  /**
     * Apartment selector 2016
     * Author: Fabriken Webbyrå AB
     * Year:2016
     * Useage example:
     * $(document).ready(function () {
     $("#bostadsvaljare").apartmentSelector(
     {
     appID: "4DOADLFD0DOGS9J6", //Project ID
     views: 2, //Views check apartments folder for the count of views.
     debug: false
     }
     );
     });
     * @param {Object} options
     * @returns {undefined}
     */
  $.fn.apartmentSelector = function (options) {
    //__construct
    var self = this;

    self.settings = $.extend(
      {
        jsonUrl: "",
        jsonUrlFull: "",
        appID: "",
        views: 0,
        //appUrl: "http://app.local/apibostadsvaljaren/",
        appUrl: "https://api.bostadsvaljaren.se/",
        images: [],
        preloadImages: [],
        doubleClickOnDevice: false,
        navigate: true,
        do_ajax: false,
        new_page: false,
        debug: false,
        width: 1920,
        height: 1080,
        apartmentsInTable: 13,
        theme: "default",
        displayMode: "pagination", // 'pagination' or 'showmore'
        displayLimit: 10, // Number of rows to show initially in 'showmore' mode
        hideFilters: false, // Hide the filter sliders (room, price, area)
        hideMobileCards: false, // Hide the mobile apartment cards/slider
        mobileUI: false, // Compact mobile mode: hide filters + limit rows, reveal on 'Visa mer'
      },
      options
    );  

    if (
      self.settings.jsonUrl === "" ||
      self.settings.appID === "" ||
      !supportsSVG()
    ) {
      self.remove();
      console.log("Invalid settings for apartmentSelector");
      return false;
    }

    if (self.settings.debug) {
      self.settings.appUrl += "dev/";
    }

    self.settings.jsonUrl = self.settings.jsonUrl + self.settings.appID;

    if (self.settings.jsonUrlFull !== "") {
      self.settings.jsonUrl = self.settings.jsonUrlFull;
    }

    self.dom_id = $(this).attr("id");
    self.activeView = "";
    self.apartments = [];
    self.statusTypes = [
      ["available", "Till salu"],
      ["no_sale", "Ej till salu"],
      ["reserved", "Reserverad"],
      ["booked", "Bokad"],
      ["sold", "Såld"],
      ["sell_later", "Säljs senare"],
      ["upcomming", "Kommande"],
      ["display", "Visningsbostad"],
      [null, "-"],
    ];
    self.svgViews = [];
    self.popup = new app_popup(self);
    self.svg_cont = Snap("#svg");
    self.configUrl =
      self.settings.appUrl +
      "gf-apartments/" +
      self.settings.appID +
      "/config.json";
    self.imagesUrl =
      self.settings.appUrl + "gf-apartments/" + self.settings.appID;
    self.hasSvg = supportsSVG() ? true : false;
    self.preloader = new app_preloader(self);
    self.ajax = new app_ajax(self.settings.jsonUrl, "single-apartment");
    self.dtable = null;
    self.settings.currentView = 3;
    self.isAnimating = false;
    self.firstAnimation = true;
    self.hasPriceSlider = false;

    //Get JSON CONFIG
    $.getJSON(self.configUrl, function (json) {
      self.settings.views = json.views;
      self.settings.width = json.width;
      self.settings.height = json.height;
      self.settings.info = json.info ? json.info : false;
      self.settings.view_names = json.view_names ? json.view_names : false;
      self.settings.animation = json.animation ? json.animation : false;
      self.settings.animationImages = [];

      //Set images & svg depending on views in config!
      for (var i = 1; i < self.settings.views + 1; i++) {
        var imageO = {
          view: i,
          url: self.imagesUrl + "/view" + i + ".jpg",
          main: true,
        };

        self.settings.images.push(self.imagesUrl + "/view" + i + ".jpg");
        self.settings.preloadImages.push(imageO);
        self.svgViews.push(self.imagesUrl + "/view" + i + ".svg");

        if (self.settings.animation) {
          // let index = i-1

          for (var j = 0; j < self.settings.animation[i]; j++) {
            var imageA = {
              view: i,
              url:
                self.imagesUrl +
                "/animation/view" +
                i +
                "/view_" +
                i +
                "_" +
                j +
                ".jpg",
              main: false,
              index: j,
              elm: null,
            };

            self.settings.animationImages.push(imageA);
            self.settings.preloadImages.push(imageA);
          }
        }
      }

      // console.log(self.settings.preloadImages);

      $(window).trigger("apartment_construct_completed");

      init();
    });

    /** Construct DONE **/

    /**
     * Init
     * @returns {undefined}
     */
    var init = function () {
      $("body").addClass("apartment_selector").addClass(self.settings.theme);

      self.trace("Building App");
      //Generate CSS
      self.css = new app_css(self.dom_id, self.settings.appUrl);
      //Generate HTML
      self.html(new app_html(self.settings).gethtml());
      //Showing preloader
      self.preloader.show();
      //Setup json data
      self.setUpData();

      //Show All
      //REMOVE ME LATER
      self.find("input#showAll").trigger('click');
    };

    /**
     * Go to previous view
     *
     */
    self.prev = function () {
      var view = self.settings.currentView - 1;

      if (view == 0) {
        view = self.settings.views;
      }

      $("body")
        .find("#changeView" + view)
        .trigger("click");
    };

    /**
     * Go to next view
     *
     */
    self.next = function () {
      var view = self.settings.currentView + 1;

      if (view > self.settings.views) {
        view = 1;
      }

      $("body")
        .find("#changeView" + view)
        .trigger("click");
    };

    /**
     * Get images to
     */
    self.getAllImagesBetween = function (from, to) {
      var max = self.settings.views;
      var min = 1;
      var half = max / 2;
      var raw_diff = from > to ? from - to : to - from;
      var mod_diff = raw_diff % max;
      var dist = mod_diff > half ? max - mod_diff : mod_diff;

      var direction =
        (from + dist) % max == to || ((from + dist) % max == 0 && from < to)
          ? "forward"
          : "backward";

      // console.log("DAATA");
      // console.log(max,half,raw_diff,mod_diff,dist);
      // console.log((from + dist) % max);

      var views = [];
      var images = [];

      // console.log(direction, from, to);

      if (direction === "forward") {
        for (var i = from; i <= from + dist; i++) {
          if (i > max) {
            views.push(i - max);
          } else {
            views.push(i);
          }
        }
      } else {
        for (var i = from; i >= from - dist; i--) {
          if (i < min) {
            views.push(i + max);
          } else {
            views.push(i);
          }
        }
      }

      for (var i = 0; i < views.length; i++) {
        if (
          (i + 1 === views.length && direction === "forward") ||
          (i === 0 && direction === "backward")
        ) {
          continue;
        }

        var allImages = self.settings.animationImages.slice();

        if (direction === "backward") {
          allImages = allImages.reverse();
        }

        for (var j = 0; j < allImages.length; j++) {
          var img = allImages[j];

          if (img.view == views[i]) {
            images.push(img);
          }
        }
      }

      return images;
    };

    self.lastframe = null;

    self.animate = function (view, cb) {
      var images = self.getAllImagesBetween(self.settings.currentView, view);

      if (images.length > 0) {
        // console.log("animate", view, images);
        // $("body").find("#animation img").css({ opacity: 0 });

        // images[0].elm[0].style.opacity = 1;

        // $("body").find("#animation img").each(function(i,elm){
        //     var e = $(elm);
        //     if (e[0] !== images[0].elm[0]){
        //         e[0].style.opacity = 0;
        //     }
        // });

        var index = 0;
        var lastIndex = 0;

        var startTime = new Date().getTime();

        var ann = function () {
          var now = new Date().getTime();

          if (now - startTime >= 25) {
            startTime = now;

            images[index].elm[0].style.opacity = 1;

            if (index === 0) {
              if (self.lastframe != null) {
                self.lastframe.elm[0].style.opacity = 0;
                self.lastframe = null;
              }
            } else {
              images[lastIndex].elm[0].style.opacity = 0;
            }

            if (index === images.length - 1) {
              self.lastframe = images.pop();
              cb();
              return;
            }
            lastIndex = index;
            index++;
          }

          window.requestAnimationFrame(ann);
        };

        window.requestAnimationFrame(ann);
      } else {
        cb();
      }
    };

    self.loop = function (index, images) {};

    self.displayAnimation = function () {};

    /**
     * Adding binds
     * @returns {undefined}
     */
    self.addBinds = function () {
      self
        .find(".changeView a:not('.external')")
        .bind("click", self.changeView);

      if (self.settings.animation) {
        self.find("#animation-play-left").bind("click", self.prev);
        self.find("#animation-play-right").bind("click", self.next);
      }

      self.find("input#showAll").change(self.toggleAllForSale);

      if (self.settings.theme == "aromalund") {
        self.find("div.character > input").change(self.filterApparments);
      }

      self.filterApparments();
      self.find("#changeView1").trigger("click");

      // Initialize mobile apartment list
      self.initMobileApartmentList();

      self.preloader.hide();

      $("html").addClass("svg");

      $("body").find(".apartment_list tr.navigate").bind("click", self.trCLick);
      var isShowMore = self.settings.displayMode === "showmore";
      var isMobileUI = self.settings.mobileUI === true || self.settings.mobileUI === "true";

      self.dtable = $("#apartmenttable").DataTable({
        searching: true,
        pageLength: isShowMore ? -1 : (isMobileUI ? self.settings.displayLimit : self.settings.apartmentsInTable),
        paging: !isShowMore,
        lengthChange: false,
        responsive: true,
        order: [[0, "desc"]],
        pagingType: "simple_numbers",
        // columnDefs: [{
        //         orderable: !1,
        //         targets: 20
        //     }, {
        //         type: "formatted-num",
        //         targets: 4
        //     }],
        columnDefs: [
          {
            type: "string",
            targets: 0,
          },
          // {
          //     type: "formatted-num",
          //     targets: 6
          // },
          {
            type: "formatted-num",
            targets: 3,
          },
        ],
        fnDrawCallback: function (oSettings) {
          var api = new $.fn.dataTable.Api(oSettings);
          var pageInfo = api.page.info();

          if (pageInfo.pages <= 1) {
            $(oSettings.nTableWrapper).find(".dataTables_paginate").hide();
          } else {
            $(oSettings.nTableWrapper).find(".dataTables_paginate").show();
          }

          // Re-apply show more limit after every draw (sort, filter, etc.)
          if (self.settings.displayMode === "showmore") {
            self.applyShowMoreLimit();
          }
          if (isMobileUI && !self.mobileUIExpanded) {
            // Hide pagination in mobileUI until expanded
            $(oSettings.nTableWrapper).find(".dataTables_paginate").hide();
          }
        },
        language: {
          emptyTable: "Tabellen innehåller ingen data",
          info: "Visar _START_ till _END_ av _TOTAL_ lägenheter",
          infoEmpty: "Det finns inga lägenheter att visa",
          infoFiltered: "(filtrerade från totalt _MAX_ rader)",
          infoPostFix: "",
          infoThousands: " ",
          lengthMenu: "Visa _MENU_ rader",
          loadingRecords: "Laddar...",
          processing: "Bearbetar...",
          search: "Sök:",
          zeroRecords: "Hittade inga matchande lägenheter",
          paginate: {
            first: "Första",
            last: "Sista",
            next: "Nästa",
            previous: "Föregående",
          },
          aria: {
            SortAscending:
              ": aktivera för att sortera kolumnen i stigande ordning",
            SortDescending:
              ": aktivera för att sortera kolumnen i fallande ordning",
          },
        },
        initComplete: function () {
          $("#apartmenttable").wrap(
            '<div class="apartments-table-responsive"></div>'
          );

          // Show more / show less button logic
          if (isShowMore) {
            self.showMoreLimit = self.settings.displayLimit;
            self.showMoreExpanded = false;

            var $btnWrap = $('<div class="gas-showmore-wrap"></div>');
            self.$showMoreBtn = $('<button type="button" class="gas-showmore-btn">Visa mer</button>');
            $btnWrap.append(self.$showMoreBtn);
            // Place button after the info text
            var $info = $("#apartmenttable").closest(".dataTables_wrapper").find(".dataTables_info");
            if ($info.length) {
              $info.after($btnWrap);
            } else {
              $("#apartmenttable").closest(".apartments-table-responsive").after($btnWrap);
            }

            self.$showMoreBtn.on("click", function () {
              self.showMoreExpanded = !self.showMoreExpanded;
              self.applyShowMoreLimit();
            });

            self.applyShowMoreLimit();
          }

          // Mobile UI: hide filters + pagination initially, reveal on click
          if (isMobileUI) {
            self.mobileUIExpanded = false;

            // Hide filters, showall checkbox (only on mobile), and pagination
            if ($(window).outerWidth() < 768) {
              $("#sliders").hide();
              $("#characterSelect").hide();
              $(".showall").hide();
            }
            $("#apartmenttable").closest(".dataTables_wrapper").find(".dataTables_paginate").hide();

            var $mobileBtn = $('<div class="gas-showmore-wrap gas-mobileui-wrap"></div>');
            self.$mobileUIBtn = $('<button type="button" class="gas-showmore-btn">Visa mer</button>');
            $mobileBtn.append(self.$mobileUIBtn);
            var $mInfo = $("#apartmenttable").closest(".dataTables_wrapper").find(".dataTables_info");
            if ($mInfo.length) {
              $mInfo.after($mobileBtn);
            } else {
              $("#apartmenttable").closest(".apartments-table-responsive").after($mobileBtn);
            }

            self.$mobileUIBtn.on("click", function () {
              self.mobileUIExpanded = !self.mobileUIExpanded;

              if (self.mobileUIExpanded) {
                // Show filters and pagination
                if ($(window).outerWidth() < 768) {
                  $("#sliders").show();
                  $("#characterSelect").show();
                  $(".showall").show();
                }

                // Switch to apartmentsInTable page length
                self.dtable.page.len(self.settings.apartmentsInTable).draw();

                // Move button after pagination
                $("#apartmenttable").closest(".dataTables_wrapper").find(".dataTables_paginate").after($mobileBtn);

                self.$mobileUIBtn.text("Visa mindre");
              } else {
                // Hide filters on mobile and pagination
                if ($(window).outerWidth() < 768) {
                  $("#sliders").hide();
                  $("#characterSelect").hide();
                  $(".showall").hide();
                }

                // Switch back to displayLimit page length and hide pagination
                self.dtable.page.len(self.settings.displayLimit).draw();
                $("#apartmenttable").closest(".dataTables_wrapper").find(".dataTables_paginate").hide();

                // Move button back after info text
                var $mInfoBtn = $("#apartmenttable").closest(".dataTables_wrapper").find(".dataTables_info");
                if ($mInfoBtn.length) {
                  $mInfoBtn.after($mobileBtn);
                }

                self.$mobileUIBtn.text("Visa mer");
              }

              setTimeout(function () {
                iframeRez();
              }, 50);
            });

            // Resize listener: toggle filter visibility when crossing 768px breakpoint
            $(window).on("resize.mobileUI", function () {
              if (self.mobileUIExpanded) return;
              if ($(window).outerWidth() < 768) {
                $("#sliders").hide();
                $("#characterSelect").hide();
                $(".showall").hide();
              } else {
                $("#sliders").show();
                $("#characterSelect").show();
                $(".showall").show();
              }
            });
          }
        },
      });
      self.trace("All binds loaded!");
    };

    self.trCLick = function (event) {
      event.preventDefault();
      var tr = $(this);
      var id = tr.attr("data-id");
      id = id.replace("-", "_");
      var link = tr.attr("data-permalink");
      if (link !== "") {
        var clickedElement = event.currentTarget;
        var elementOffsetTop = $(clickedElement).offset().top;
        self.showApparment(id, link, elementOffsetTop);
      } else {
        // console.log("no link..");
      }
    };

    /**
     * Fetching json data
     * @returns {undefined}
     */
    self.setUpData = function () {
      $.getJSON(self.settings.jsonUrl, function (json) {
        if (!$.isEmptyObject(json.apts)) {
          var jsondata = json.apts;
          self.trace("-----JSON DATA LOADED------");
          $.each(jsondata, function (key, value) {
            value.orig_lghnr = value.std_LghNr;
            value.std_LghNr = value.std_LghNr.replace(".", "_");
            // value.std_LghNr = value.std_LghNr.replace(/[^a-zA-Z0-9-_]/gi, '');
            // value.std_LghNr = value.std_LghNr.replace(':', '_');

            if (
              self.settings.theme === "gfvyn" ||
              self.settings.theme === "aros"
            ) {
              value.std_LghNr = value.std_LghNr.replace("-", "_");
            }

            //Dev Mode
            if (value.available === "draft") {
              return;
            } else {
              value.rooms = value.rooms.replace(",", ".");
              value.roomsDisplay = value.rooms;
              value.rooms = value.rooms.split("-");
              value.rooms = missingNumbers(value.rooms);
              value.size = value.size.replace(",", ".");

              if (
                self.settings.theme !== "viste" ||
                self.settings.theme !== "fjallet"
              ) {
                if (typeof value.bi_size != undefined && value.bi_size > 0) {
                  value.bi_size = value.bi_size.replace(",", ".");
                } else {
                  value.bi_size = "";
                }
              }

              self.apartments.push(value);
            }
          });

          self.apartments.sort(SortByLgh);

          self.trace("-----LOAD IMAGES------");
          //Load images and setup slider!
          app_preloadPictures(
            self.settings.preloadImages,
            self.setupSliders.bind(self),
            self.settings.animation
          );
          self.trace("-----JSON DATA COMPLETED------");
        } else {
          self.remove();
          console.log("Could not load data");
        }
      });
    };

    /**
     * Setup app sliders!
     * @returns {undefined}
     */
    self.setupSliders = function () {
      console.log("Setting up sliders..");

      // Hide filters if setting is enabled
      if (self.settings.hideFilters) {
        $("#sliders").hide();
        $("#characterSelect").hide();
        $(".showall").hide();
        self.addBinds();
        return;
      }

      // filter actions
      var highestArea = 0;
      var lowestArea = 999;
      var highestPrice = 0;
      var lowestPrice = 0;
      var lowestRoom = 1;
      var highestRoom = 1;

      for (var i in self.apartments) {
        lowestArea =
          Number(self.apartments[i].size) < lowestArea
            ? Number(self.apartments[i].size)
            : lowestArea;
        highestArea =
          Number(self.apartments[i].size) > highestArea
            ? Number(self.apartments[i].size)
            : highestArea;

        for (var x in self.apartments[i].rooms) {
          if (Number(self.apartments[i].rooms[x]) > 0) {
            lowestRoom =
              Number(self.apartments[i].rooms[x]) < lowestRoom
                ? Number(self.apartments[i].rooms[x])
                : lowestRoom;
            highestRoom =
              Number(self.apartments[i].rooms[x]) > highestRoom
                ? Number(self.apartments[i].rooms[x])
                : highestRoom;
          }
        }

        if (parseInt(self.apartments[i].price) > 0) {
          lowestPrice =
            Number(self.apartments[i].price) < lowestPrice
              ? Number(self.apartments[i].price)
              : lowestPrice;
          highestPrice =
            Number(self.apartments[i].price) > highestPrice
              ? Number(self.apartments[i].price)
              : highestPrice;
        }
      }

      if (lowestArea == highestArea) {
        lowestArea = 1;
      }

      if (lowestRoom == highestRoom) {
        lowestRoom = 1;
      }

      /**
       * Disable
       */
      if (lowestPrice == highestPrice) {
        console.error("JEJE");
        highestPrice = 0;
      }

      self.trace("Lowest Area: " + lowestArea);
      self.trace("Highest Area: " + highestArea);
      self.trace("Lowest Price: " + lowestPrice);
      self.trace("Highest Price: " + highestPrice);
      self.trace("Lowest Room: " + lowestRoom);
      self.trace("Highest Room: " + highestRoom);

      self.roomSlider = new app_slider(
        $("#sliderRum"),
        lowestRoom,
        highestRoom,
        $("#roomet"),
        false,
        self.filterApparments
      );
      self.areaSlider = new app_slider(
        $("#sliderBo"),
        lowestArea,
        highestArea,
        $("#boarea"),
        "m²",
        self.filterApparments
      );

      if (highestPrice > 0) {
        self.hasPriceSlider = true;
        self.priceSlider = new app_slider(
          $("#sliderPrice"),
          lowestPrice,
          highestPrice,
          $("#price"),
          "kr",
          self.filterApparments
        );
      } else {
        $("#sliderPris").hide();
      }

      self.addBinds();
    };

    /**
     * Change view
     * @param {Event} event
     */
    self.changeView = function (event) {
      if (self.isAnimating) {
        return;
      }

      if (self.firstAnimation) {
        $("#view" + self.settings.currentView).show();
        self.firstAnimation = false;
      }

      event.stopPropagation();
      event.preventDefault();
      var obj = $(this);
      var svg_cont = Snap("#svg");

      if (!obj.hasClass("active")) {
        self.isAnimating = true;

        var id = obj.attr("id");
        var did = obj.attr("data-id");
        id = id.replace("changeView", "view");

        // console.log(id);

        var cid = parseInt(id.replace("view", ""));

        if (self.settings.animation) {
          $("#svg").hide();

          self.animate(cid, function () {
            self.settings.currentView = cid;

            $("#svg").show();
            $(".view").hide();
            $("#" + id).show();
            // $("body").find("#animation img").css({ opacity: 0 });
            // $("body").find("#animation").css({height: "0px" });

            $(".changeView").find("a").removeClass("active");
            obj.addClass("active");
            self.activeView = "#" + id;
            self.trace("Showing view: #" + id);
            self.isAnimating = false;
          });
        } else {
          self.settings.currentView = cid;

          $(".changeView").find("a").removeClass("active");
          obj.addClass("active");

          $(".view").hide();
          $("#" + id).show();

          self.activeView = "#" + id;
          self.trace("Showing view: #" + id);
          self.isAnimating = false;
        }

        svg_cont.clear();

        var lastClicked = null;
        //Snap.load($app.svgViews[did] + "?rand=" + Math.random() * 100, function (f) {
        //Snap.load($app.svgViews[did], function (f) {
        $(document).load(self.svgViews[did], function (f) {
          f = Snap.parse(f);
          var g = f.selectAll("polygon,rect,path");
          g.forEach(function (app) {
            var id = app.node.id;
            var isInfo = false;
            if (id.indexOf("info_") !== -1) {
              isInfo = true;
            }

            var poly = app;
            if (self.getAppartment(id) && poly) {
              poly.attr({ class: self.getAppartment(id).available, fill: "" });
            } else if (isInfo && poly) {
              poly.attr({ class: "info", fill: "" });
            } else {
              poly.attr({ class: "not_for_sale", fill: "" });
            }

            poly
              .hover(
                function () {
                  if (isInfo) {
                    self.popup.showPopUpInfo(id);
                  } else {
                    self.popup.showPopUp(self.getAppartment(id));
                  }
                },
                function () {
                  self.popup.hidePopUp();
                }
              )
              .click(function (event) {
                var clickedElement = event.currentTarget;
                var elementOffsetTop = $(clickedElement).offset().top;

                if (
                  self.getAppartment(id).available == "available" ||
                  self.getAppartment(id).available == "reserved" ||
                  isInfo
                ) {
                  var ww = $(window).outerWidth();
                  var data = null;
                  var link = false;

                  if (isInfo) {
                    data = self.popup.get_info(id);

                    // console.log(data);
                    if (data.link !== "") {
                      if (data.link.indexOf("popup:") !== -1) {
                        var url = data.link.replace("popup:", "");

                        $.featherlight(url);
                        return false;
                      }

                      if (data.link.indexOf("view") !== -1) {
                        var view =
                          parseInt(data.link.replace("view", "")) > 0
                            ? parseInt(data.link.replace("view", ""))
                            : 1;
                        $("#changeView" + view).trigger("click");
                        return false;
                      }
                      link = data.link;
                    }
                  } else {
                    link = self.getAppartment(id).url;
                  }

                  if (ww > 768 || !self.settings.doubleClickOnDevice) {
                    self.showApparment(id, link, elementOffsetTop);
                  } else {
                    if (id == lastClicked) {
                      self.showApparment(id, link, elementOffsetTop);
                    }
                  }

                  lastClicked = id;
                }

                return false;
                //location.href = apps[id].Url;
              });
          });

          svg_cont.append(g);

          self.filterApparments();
          self.toggleAllForSale();
        });
      }
    };

    self.showApparment = function (id, link, offsetTop) {
      if (self.settings.navigate && link && link !== "") {
        if (self.settings.do_ajax) {
          var apartment = self.getAppartment(id);

          if (
            apartment &&
            apartment.available &&
            (apartment.available == "available" ||
              apartment.available == "reserved")
          ) {
            self.ajax.do_ajax(self.getAppartment(id).GUID, offsetTop);
          } else {
            console.log("Not available");
          }
        } else {
          if (self.settings.new_page) {
            var win = window.open(link, "_blank");
            win.focus();
          } else {
            window.location = link;
          }
        }
      }
    };

    // filter apps: with slider and check
    self.filterApparments = function () {
      self.resetSvgElements();

      var allAppartments = [];
      for (var i in self.apartments) {
        allAppartments.push(self.apartments[i]);
      }

      //filter from values from sliders!
      var newAppartments = $.grep(
        allAppartments,
        function (s) {
          var result = true;

          if (s.available === "no_sale") {
            return true;
          }

          if (typeof s.price === undefined || typeof s.size === undefined)
            return false;

          // Skip slider filtering if filters are hidden
          if (self.settings.hideFilters) {
            return true;
          }

          if (
            self.settings.theme === "aromalund" &&
            self.settings.appID !== "f0e5e9ef2befb369c01689fbaa35320a81a30cfd"
          ) {
            var values = Array();

            self
              .find(".character input[name='character[]']:checked")
              .each(function (elm) {
                values.push($(this).val());
              });

            if (values.indexOf(s.character) == -1) {
              return false;
            }
          }

          for (var p in s.rooms) {
            if (
              Number($("#sliderRum").slider("values", 0)) <=
                Number(s.rooms[p]) &&
              Number($("#sliderRum").slider("values", 1)) >=
                Number(s.rooms[p]) &&
              result
            ) {
              result = false;
            }
          }
          // console.log(s.price);

          if (self.hasPriceSlider) {
            return (
              (s.available !== "available" ||
                s.available !== "upcomming" ||
                s.available !== "reserved") &&
              Number($("#sliderPrice").slider("values", 0)) <=
                Number(s.price) &&
              Number($("#sliderPrice").slider("values", 1)) >=
                Number(s.price) &&
              Number($("#sliderBo").slider("values", 0)) <=
                Number(s.size) + 1 &&
              Number($("#sliderBo").slider("values", 1)) >=
                Number(s.size) - 1 &&
              !result
            );
          } else {
            return (
              (s.available !== "available" ||
                s.available !== "upcomming" ||
                s.available !== "reserved") &&
              Number($("#sliderBo").slider("values", 0)) <=
                Number(s.size) + 1 &&
              Number($("#sliderBo").slider("values", 1)) >=
                Number(s.size) - 1 &&
              !result
            );
          }

          // return ((s.available !== "available" || s.available !== "upcomming" || s.available !== "reserved")
          //         && (Number($("#sliderBo").slider("values", 0)) <= Number(s.size) + 1)
          //         && (Number($("#sliderBo").slider("values", 1)) >= Number(s.size) - 1)
          //         && !result);
        },
        true
      );

      //self.showTable();
      var elementsToHide = [];

      //Highlight new apartments!
      for (var k in newAppartments) {
        //show filtered
        if (newAppartments[k].std_LghNr !== undefined) {
          self.trace(newAppartments[k].std_LghNr);

          var sid = newAppartments[k].std_LghNr;

          if (sid !== undefined) {
            var svg_element = document.getElementById("" + sid)
              ? document.getElementById("" + sid)
              : null;
            //var mySVG = $('#svg #' + sid).length ? $('#svg #' + sid) : null;

            if (svg_element !== null) {
              svg_element.addClass("filter");
            }

            elementsToHide.push(newAppartments[k].orig_lghnr);
          }
        }
      }

      self.redraw(elementsToHide);

      // Update mobile apartment list when filters are applied
      // if ($(window).outerWidth() < 768) {
      //     self.populateApartmentList();
      //     self.initApartmentNavigation();
      // }
    };

    // Show more / show less: hide/show rows beyond the limit
    self.applyShowMoreLimit = function () {
      if (self.settings.displayMode !== "showmore") return;

      // Get only the rows DataTable considers visible (not filtered out)
      var visibleRows = $("#apartmenttable tbody tr").not(".gas-hidden-row");
      var allRows = $("#apartmenttable tbody tr");

      // First remove all our hiding so we work with DataTable's current state
      allRows.removeClass("gas-hidden-row");

      // Re-count after removing our class — these are rows DataTable shows
      var dtVisibleRows = $("#apartmenttable tbody tr:not([style*='display: none'])");
      var totalVisible = dtVisibleRows.length;

      if (self.showMoreExpanded) {
        if (self.$showMoreBtn) {
          self.$showMoreBtn.text("Visa mindre");
        }
      } else {
        var count = 0;
        dtVisibleRows.each(function () {
          count++;
          if (count > self.showMoreLimit) {
            $(this).addClass("gas-hidden-row");
          }
        });
        if (self.$showMoreBtn) {
          self.$showMoreBtn.text("Visa mer");
        }
      }

      // Hide button if total visible rows fit within limit
      if (self.$showMoreBtn) {
        if (totalVisible <= self.showMoreLimit) {
          self.$showMoreBtn.parent().hide();
        } else {
          self.$showMoreBtn.parent().show();
        }
      }

      // Update info text to reflect visible count
      var shownCount = self.showMoreExpanded ? totalVisible : Math.min(totalVisible, self.showMoreLimit);
      $(".dataTables_info").text(
        "Visar 1 till " + shownCount + " av " + totalVisible + " lägenheter"
      );

      // Delay iframeRez so browser recalculates layout after DOM changes
      setTimeout(function () {
        iframeRez();
      }, 50);
    };

    self.redraw = function (elementsToHide) {
      if (self.dtable !== null) {
        $.fn.dataTable.ext.search.pop();
        self.dtable.draw();

        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
          if (elementsToHide.length === 0) {
            return true;
          }

          if (
            self.settings.theme === "aromalund" ||
            self.settings.theme === "viste" ||
            self.settings.theme === "fjallet" ||
            self.settings.theme === "aros"
          ) {
            var string = data[0].replace(":", "_");
            // string = data[0].replace('-', '0');
            string = data[0].trim();
            // console.log(string);
            return elementsToHide.indexOf(string) === -1 ? true : false;
          } else {
            var string = data[1].replace(":", "_");
            // string = data[1].replace('-', '0');
            string = data[1].trim();
            // console.log(string);

            return elementsToHide.indexOf(string) === -1 ? true : false;
          }
        });

        self.dtable.draw();

        // Reset show more state when filters change
        if (self.settings.displayMode === "showmore") {
          self.showMoreExpanded = false;
        }
      }
    };

    /**
     * Show all apartments that are forsale
     * @todo redo whole function!
     * @returns {undefined}
     */
    self.toggleAllForSale = function () {
      var elementsToHide = [];

      for (var i in self.apartments) {
        //show filtered
        var svg_element = null;
        var sid = null;
        if ($("input#showAll").is(":checked")) {
          // $(
          //   "#controls div.checks, #controls #sliders, #controls #characterSelect"
          // ).addClass("disabled");
          sid = self.apartments[i].std_LghNr;
          // if (self.apartments[i].available == 'available' || self.apartments[i].available == 'upcomming') {
          if (sid !== undefined) {
            svg_element = document.getElementById("" + sid)
              ? document.getElementById("" + sid)
              : null;

            if (svg_element !== null) {
              svg_element.addClass("hilight");
            }
          }
          // } else {
          //         elementsToHide.push(sid);
          // }
        } else {
          // $(
          //   "#controls div.checks, #controls #sliders, #controls #characterSelect"
          // ).removeClass("disabled");
          sid = self.apartments[i].std_LghNr;
          if (sid !== undefined) {
            svg_element = document.getElementById("" + sid)
              ? document.getElementById("" + sid)
              : null;
            if (svg_element !== null) svg_element.removeClass("hilight");
          }
        }
      }
      self.redraw(elementsToHide);

      // Update mobile apartment list when "Show All" is toggled
      // if ($(window).outerWidth() < 768) {
      //     self.populateApartmentList();
      //     self.initApartmentNavigation();
      // }
    };

    //Get one apartment from the apartments!
    self.getAppartment = function (id) {
      //Get apartment
      var ret = false;
      if (id !== "") {
        $.each(self.apartments, function (key, value) {
          var obj = value;

          if (obj.std_LghNr == id) {
            ret = obj;
            return false;
          }
        });
      }

      if (id.indexOf("info_") !== -1) {
        return false;
      }

      if (!ret) self.trace("Didnt fin the apartment with ID: " + id);

      return ret;
    };

    /**
     * Reset svg elements
     * @returns {undefined}
     */
    self.resetSvgElements = function () {
      $("#svg polygon,#svg rect,#svg path").each(function () {
        var svg_element = this;
        if (svg_element !== null) svg_element.removeClass("filter");
      });
    };

    /**
     * Get nice status
     * @param {string} input
     * @returns {string}
     */
    self.statusTranslate = function (input) {
      for (var i in self.statusTypes) {
        if (input == self.statusTypes[i][0]) {
          return self.statusTypes[i][1];
        }
      }
    };

    //Trace statements
    self.trace = function (v, condebug) {
      if (self.settings.debug) {
        traceit(v, condebug, self);
      }
    };

    /**
     * Initialize mobile apartment list
     */
    self.initMobileApartmentList = function () {
      // Hide mobile cards entirely if setting is enabled
      if (self.settings.hideMobileCards) {
        $("#available-apartments-wrapper").css({
          display: "none",
          height: "0",
          overflow: "hidden",
          visibility: "hidden",
          position: "absolute"
        });
        return;
      }

      // Wait for DOM to be ready
      $(document).ready(function () {
        self.populateApartmentList();

        // Only show on mobile devices
        if ($(window).outerWidth() < 768) {
          $("#available-apartments-wrapper").show();
        }

        // Handle window resize
        $(window).on("resize", function () {
          if ($(window).outerWidth() < 768) {
            $("#available-apartments-wrapper").show();
          } else {
            $("#available-apartments-wrapper").hide();
          }
        });
      });
    };

    /**
     * Populate apartment list with available apartments
     */
    self.populateApartmentList = function () {
      var apartmentHtml = "";
      var availableApartments = self.apartments.filter(function (apartment) {
        return apartment.available === "available";
      });

      availableApartments.forEach(function (apartment, index) {
        apartmentHtml += self.createApartmentCard(apartment, index);
      });

      $("#available-apartments").html(apartmentHtml);

      // Initialize or refresh Slick slider after adding apartments
      if (availableApartments.length > 0) {
        // Destroy existing slider if it exists
        if ($("#available-apartments").hasClass("slick-initialized")) {
          $("#available-apartments").slick("unslick");
        }

        // Wait for DOM to be fully ready and then initialize Slick slider
        setTimeout(function () {
          // Double check that element still exists and has content
          if (
            $("#available-apartments").length &&
            $("#available-apartments").children().length > 0
          ) {
            self.initApartmentNavigation();
          }
        }, 500); // Reduced timeout and added DOM check
      }
    };

    /**
     * Create apartment card HTML
     */
    self.createApartmentCard = function (apartment, index) {
      var statusClass =
        apartment.available === "available" ? "available" : "upcoming";
      var statusText = self.statusTranslate(apartment.available);
      var priceDisplay =
        apartment.price > 0
          ? addCommas(apartment.price, apartment.available) + " kr"
          : "Kontakta mäklare";
      var roomsDisplay = apartment.roomsDisplay || apartment.rooms.join("-");
      var sizeDisplay = apartment.size
        ? apartment.size.replace(".", ",") + " m²"
        : "";

      var cardHtml =
        '<div class="apartment-card" data-apartment-id="' +
        apartment.std_LghNr +
        '">';

      // Header with apartment number and status
      cardHtml += '<div class="apartment-card-header">';
      cardHtml += '<div class="apartment-number">' + apartment.name + "</div>";
      cardHtml +=
        '<div class="apartment-status ' +
        statusClass +
        '">' +
        statusText +
        "</div>";
      cardHtml += "</div>";

      // Details section
      cardHtml += '<div class="apartment-details">';
      cardHtml +=
        '<div class="detail-item"><strong>Pris:</strong> ' +
        priceDisplay +
        "</div>";
      cardHtml +=
        '<div class="detail-item"><strong>Storlek:</strong> ' +
        sizeDisplay +
        "</div>"; 
      cardHtml +=
        '<div class="detail-item"><strong>Antal rum:</strong> ' +
        roomsDisplay +
        "</div>";
      cardHtml += "</div>";

      // Floor plan image if available
      if (apartment.floorPlanUrl) {
        cardHtml += '<div class="floor-plan-container">';
        cardHtml +=
          '<img src="' +
          apartment.floorPlanUrl +
          '" alt="Planritning ' +
          apartment.name +
          '" class="floor-plan-image" />';
        cardHtml += "</div>";
      } else if (apartment.std_LghNr) {
        // Try to construct floor plan URL if not directly available
        var floorPlanUrl =
          self.imagesUrl +
          "/apartments/" +
          apartment.std_LghNr +
          "/floorplan.jpg";
        cardHtml += '<div class="floor-plan-container">';
        cardHtml +=
          '<img src="' +
          floorPlanUrl +
          '" alt="Planritning ' +
          apartment.name +
          '" class="floor-plan-image" onerror="this.parentElement.style.display=\'none\'" />';
        cardHtml += "</div>";
      }

      // Green button
      cardHtml += '<div class="apartment-actions">';
      cardHtml +=
        '<button class="apartment-view-btn" data-apartment-id="' +
        apartment.std_LghNr +
        '">Läs mer</button>';
      cardHtml += "</div>";

      cardHtml += "</div>";

      return cardHtml;
    };

    /**
     * Initialize apartment navigation with Slick slider
     */
    self.initApartmentNavigation = function () {
      // Check if Slick is available
      if (typeof $.fn.slick === "undefined") {
        console.error(
          "Slick slider is not loaded. Please include slick.min.js"
        );
        return;
      }

      // Check if container exists and has apartments
      var $container = $("#available-apartments");
      if (!$container.length) {
        console.log("Available apartments container not found");
        return;
      }

      if ($container.children().length === 0) {
        console.log("No apartments to display in slider");
        return;
      }

      // Ensure container is visible and properly sized
      if (!$container.is(":visible")) {
        console.log("Container is not visible, waiting...");
        setTimeout(function () {
          self.initApartmentNavigation();
        }, 200);
        return;
      }

      // Initialize Slick slider
      try {
        $container.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: true,
          speed: 300,
          fade: false,
          cssEase: "ease-in-out",
          adaptiveHeight: false,
          centerMode: true,
          variableWidth: true,
          swipeToSlide: true,
          touchMove: true,
          draggable: true,
          accessibility: true,
          focusOnSelect: false,
          pauseOnHover: true,
          lazyLoad: "ondemand",
          waitForAnimate: false,
        });

        // Add click handlers for apartment view buttons
        $container.on("click", ".apartment-view-btn", function (e) {
          e.stopPropagation();
          var apartmentId = $(this).data("apartment-id");
          self.showApparment(apartmentId, "b");
        });

        // Optional: Add custom event handlers
        $container.on(
          "beforeChange",
          function (event, slick, currentSlide, nextSlide) {
            // You can add custom logic here if needed
          }
        );

        $container.on("afterChange", function (event, slick, currentSlide) {
          // You can add custom logic here if needed
        });

        console.log(
          "Slick slider initialized successfully with " +
            $container.children().length +
            " apartments"
        );
      } catch (error) {
        console.error("Error initializing Slick slider:", error);

        // Fallback: try again after a longer delay
        setTimeout(function () {
          console.log("Retrying Slick initialization...");
          self.initApartmentNavigation();
        }, 1000);
      }
    };

    /**
     * Show apartment details (integrate with existing popup system)
     */
    self.showApartmentDetails = function (apartmentId) {
      var apartment = self.getAppartment(apartmentId);
      if (apartment) {
        // Trigger the same functionality as clicking on the apartment in the SVG
        var svgElement = document.getElementById(apartmentId);
        if (svgElement) {
          $(svgElement).trigger("click");
        }
      }
    };

    /**
     * Destroy slider if needed (for cleanup)
     */
    self.destroyApartmentSlider = function () {
      if ($("#available-apartments").hasClass("slick-initialized")) {
        $("#available-apartments").slick("unslick");
      }
    };

    /**
     * Refresh slider (useful when adding/removing apartments)
     */
    self.refreshApartmentSlider = function () {
      if ($("#available-apartments").hasClass("slick-initialized")) {
        $("#available-apartments").slick("refresh");
      }
    };

    // Initialize mobile apartment list properties - removed old properties
    // Slick slider handles all navigation internally
  };
})(jQuery, window, document, Snap, app_ajax);

jQuery.extend(jQuery.fn.dataTableExt.oSort, {
  "formatted-num-pre": function (a) {
    a = a === "-" || a === "" ? 0 : a.replace(/[^\d\-\.]/g, "");
    return parseFloat(a);
  },

  "formatted-num-asc": function (a, b) {
    return a - b;
  },

  "formatted-num-desc": function (a, b) {
    return b - a;
  },
});
